// removed by extract-text-webpack-plugin
module.exports = {"text-overflow":"text-overflow___3Dv_C","header":"header___3khL7","rightWarpper":"rightWarpper___2xUuX","button":"button___2iozt","popovermenu":"popovermenu___3t7wh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Header.less
// module id = 718
// module chunks = 3